<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="messenger-box">
        <div>
          <label for="facebook-id" class="input-label">Nhập Zalo OAID tại đây:</label>
          <input id="facebook-id" class="input-field" placeholder="Nhập Zalo OAID" nz-input
            [(ngModel)]="objectChoosing.staticdata.zaloShareAttributes.data_oaid" />
            <button mat-raised-button color="primary" class="btn-update mt-2" (click)="updateStaticData()">Cập nhật</button>
        </div>
        <p class="mt-4">
          Hướng dẫn cách lấy OA ID của Zalo doanh nghiệp tại
          <span (click)="showModal()" class="guide">đây</span>
        </p>
      </div>
      <nz-modal [(nzVisible)]="isVisible"
        [nzStyle]="{ maxHeight: '80vh', top: '32px', overflowY : 'scroll', 'paddingBottom': '0' }" 
        [nzWidth]="'70%'"
        (nzOnCancel)="handleCancel()"
        (nzOnOk)="handleOk()">
        <ng-container *nzModalContent>
          <img style="width: auto; height: auto" src="/assets/root/images/system/imgs/cach_lay_oaid.jpg" />
        </ng-container>
      </nz-modal>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
      <ul nz-menu nzMode="inline" >
          <!-- Cấu hình thông số cơ bản của button-->
          <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
               <!-- Lựa chọn hiển thị cho các thiết bị -->
              <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
              </app-hide-show-config>
          </li>
          <!-- Cấu hình format font name của button -->
          <li nz-submenu nzTitle="{{'kieu_nut_chia_se'| translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
              <nz-radio-group class="zalo-button" [(ngModel)]="config.data_layout"
                  (ngModelChange)="updateConfig()">
                  <label class="zalo-label" nz-radio nzValue="1">
                      <img src="/assets/root/images/system/icons/ZaloShare_06.svg" style="width: 70px; height: 20px;">
                  </label>
                  <label class="zalo-label" nz-radio nzValue="2">
                      <img src="/assets/root/images/system/icons/ZaloShare_Dang_4.svg" style="width: 14px;">
                  </label>
                  <label class="zalo-label" nz-radio nzValue="3">
                      <img src="/assets/root/images/system/icons/ZaloShare_Dang_4.svg" style="width: 30px;">
                  </label>
                  <label class="zalo-label" nz-radio nzValue="4">
                      <img src="/assets/root/images/system/icons/ZaloShare_Dang_4.svg" style="width: 40px;">
                  </label>
                  <label class="zalo-label" nz-radio nzValue="5">
                      <img src="/assets/root/images/system/icons/ZaloShare_Dang_5.svg" style="width: 40px;">
                  </label>
              </nz-radio-group>
          </li>
      </ul>
      <div class="messenger-box">
        <div>
          <label for="facebook-id" class="input-label">Nhập Zalo OAID tại đây:</label>
          <input id="facebook-id" class="input-field" placeholder="Nhập Zalo OAID" nz-input
            [(ngModel)]="objectChoosing.staticdata.zaloShareAttributes.data_oaid" />
            <button mat-raised-button color="primary" class="btn-update mt-2" (click)="updateStaticData()">Cập nhật</button>
        </div>
        <p class="mt-4">
          Hướng dẫn cách lấy OA ID của Zalo doanh nghiệp tại
          <span (click)="showModal()" class="guide">đây</span>
        </p>
      </div>
      <nz-modal [(nzVisible)]="isVisible"
        [nzStyle]="{ maxHeight: '80vh', top: '32px', overflowY : 'scroll', 'paddingBottom': '0' }" 
        [nzWidth]="'70%'"
        (nzOnCancel)="handleCancel()"
        (nzOnOk)="handleOk()">
        <ng-container *nzModalContent>
          <img style="width: auto; height: auto" src="/assets/root/images/system/imgs/cach_lay_oaid.jpg" />
        </ng-container>
      </nz-modal>
  </ng-container>
</div>